<template>
  <div id="salemarket">
    <my-header></my-header>
    <div class="pd10">
      <div class="sale-market">
        <sale-market-head></sale-market-head>
        <ol class="breadcrumb" v-if="product">
          <li>
            <router-link :to="{ name: 'SaleMarket', params: { }}">{{'Sale Market'|translate}}</router-link>
          </li>
          <li>{{product.name}}</li>
        </ol>
        <loading
          v-if="filterVarriants == null"
          class="mt10 text-center"
          :text="'Please wait'|translate"
        ></loading>
        <div
          v-if="filterVarriants != null && filterVarriants.length == 0"
          class="alert alert-warning"
          role="alert"
        >{{'No varriant available'|translate}}</div>
        <div class="list-varriants" v-if="filterVarriants!= null">
          <ul class="list-group">
            <li class="list-group-item" v-for="(varriant) in filterVarriants" :key="varriant.id">
              <router-link
                :to="{ name: 'SaleMarketVarriant', params: { product_id: product_id, varriant_id: varriant.id, varriant_name: varriant.name }}"
              >{{varriant.name}}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
export default {
  name: "SaleMarket",
  components: {
    MyHeader,
    Loading,
    SaleMarketHead
  },
  data() {
    let data = {
      product: null,
      product_id: null,
      allVarriants: null,
      filterVarriants: null
    };

    return data;
  },

  methods: {
    getAllVarriants() {
      Utils.getAllVarriants(this, {}).then(data => {
        this.allVarriants = data;
        this.filterVarriants = this.allVarriants.filter(item => {
          return item.product_id == this.product_id;
        });
      });
    },
    getActiveProduct() {
      Utils.getAllProducts(this, {}).then(data => {
        var allProducts = data;

        var products = allProducts.filter(item => {
          return item.id == this.product_id;
        });

        if (products.length > 0) {
          this.product = products[0];
        }
      });
    }
  },
  mounted() {
    this.product_id = this.$route.params.product_id;
    this.getAllVarriants();
    this.getActiveProduct();
  },
  beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/SaleMarketProduct.vue